export default __webpack_public_path__ + "static/media/erkam_warna1.f90a98b7.png";